import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Chip from 'material-ui/Chip'

import FunctionUtils from '../../../../lambda/FunctionUtils'
import ModulesUtils from 'infra/ModulesUtils'

class WorkersModule extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape().isRequired,
    teamId: PropTypes.string,
    teamMembers: PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      list: props.jobInfo.modules.workers.list || {}
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      list: nextProps.jobInfo.modules.workers.list || {}
    })
  }

  removeWorker(worker) {
    FunctionUtils.removeWorker(this.props.teamId, this.props.jobInfo, worker.id)
  }

  selectWorker(event, index, workerId) {
    FunctionUtils.selectWorker(this.props.teamId, this.props.jobInfo, workerId)
  }

  selectForeman(worker) {
    // Allow lead only on construction jobs
    if (this.props.jobInfo.modules.lineItems) {
      let isForeman = worker.isForeman !== undefined && worker.isForeman
      FunctionUtils.updateModule(this.props.jobInfo,
        'modules/workers/list/' + worker.id + '/isForeman', !isForeman)
      // If the user became a foreman, then show a Snackbar.
      if (!isForeman) {
        const member = this.props.teamMembers.find(member => worker.id === member.userId)
        if (member) {
          ModulesUtils.showSnackbar(`${member.displayName} set as a foreman for this job.`)
        }
      }
    }
  }

  isSelected(workerId) {
    for (const key in this.state.list) {
      if (!this.state.list.hasOwnProperty(key)) {
        continue;
      }

      if (this.state.list[key].id === workerId) {
        return true;
      }
    }

    return false;
  }

  renderWorkers() {
    const views = [];
    for (const key in this.state.list) {
      if (!this.state.list.hasOwnProperty(key)) {
        continue;
      }
      const worker = this.state.list[key];
      const member = this.props.teamMembers.find(member => member.userId === worker.id)
      if (member){
        views.push(
          <Chip
            key={worker.id}
            style={{ margin: 4 }}
            backgroundColor={worker.isForeman ? '#527da3' : '#d9d9d9'}
            labelColor={worker.isForeman ? 'white' : 'black' }
            onTouchTap={() => this.selectForeman(worker)}
            onRequestDelete={() => this.removeWorker(worker)}>
            { member.displayName }
          </Chip>
        )
      }
    }

    return views;
  }

  renderItems() {
    const views = [];
    const teamMembers = this.props.teamMembers
    for(let i = 0; i < teamMembers.length; i++) {
      if (!this.isSelected(teamMembers[i].userId) && !teamMembers[i].office) {
        views.push(
          <MenuItem
            key={teamMembers[i].userId}
            value={teamMembers[i].userId}
            primaryText={teamMembers[i].displayName}/>);
      }
    }

    return views;
  }

  render() {
    return (
      <div className="horizontal-container">
        <SelectField
          style={{ width: 150 }}
          hintStyle={{ fontSize: 12, color: '#527da3' }}
          hintText="Assign"
          onChange={this.selectWorker.bind(this)}>
          {this.renderItems()}
        </SelectField>
        <div
          style={{ flexWrap: 'wrap' }}
          className="horizontal-container">
          {this.renderWorkers()}
        </div>
      </div>
    )
  }

}

function mapStateToProps(state) {
  return {
    teamId: state.firebase.team.metadata.value.id,
    teamMembers: state.firebase.team.members.value
  }
}

export default connect(mapStateToProps)(WorkersModule);



// WEBPACK FOOTER //
// ./src/schedule/common/modules/workers/WorkersModule.js